<template>
    <div>
        <div class="group shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded" @click="handleClick">
            <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
                <avatar :avatar="item.doctorAvatar" :name="item.doctorFirstName + ' ' + item.doctorLastName" class="mr-2 w-10 h-10 md:w-12 md:h-12"></avatar>
                <div class="ml-4">
                    <div class="flex items-center md:mt-1">
                        <!-- <span class="icon mr-2 text-lg text-blue-light"><i class="mdi mdi-account"></i></span> -->
                        <span class="text-sm font-bold">{{ item.doctorFirstName + ' ' + item.doctorLastName }}</span>
                    </div>
                    <div class="flex items-center">
                        <span class="icon mr-2 text-sm text-grey"><i class="mdi mdi-map-marker"></i></span>
                        <span class="text-sm text-grey font-semi-bold">{{ item.officeZipCode }} {{ item.officeLocality }}</span>
                    </div>
                    <div v-if="item.foundOffice && item.foundOffice.isDoctorMemberOfOsteopathie" class="tooltip text-green font-semibold text-sm mt-1 mb-2">
                        <i class="mdi mdi-check-circle"></i> {{ $t('Member_of_Osteopathie') }}
                        <span class="tooltip-text text-sm">{{ $t('Oste_tooltip') }}</span>
                    </div>
                    <div class="flex mb-1">
                        <template v-if="item.isDoctorRegulated && (item.type !== 'OSTEOPATH' && item.type !== 'PSYCHOLOGIST')">
                            <span class="icon mr-2 text-sm text-green"><i class="mdi mdi-currency-eur"></i></span>
                            <span class="text-sm text-green">{{ $t('Contracted_doctor') }}</span>
                        </template>
                        <template v-if="!item.isDoctorRegulated && (item.type !== 'OSTEOPATH' && item.type !== 'PSYCHOLOGIST')">
                            <span class="icon mr-2 text-sm text-red"><i class="mdi mdi-currency-eur"></i></span>
                            <span class="text-sm text-red">{{ $t('Contracted_doctor_negative') }}</span>
                        </template>
                    </div>

                    <!-- OFFICE SETTINGS -->
                    <OfficeSettings
                        v-if="item.foundOffice && item.foundOffice.officeSettings"
                        :accessible="item.foundOffice.officeSettings.accessible"
                        :card="item.foundOffice.officeSettings.card"
                        :cash="item.foundOffice.officeSettings.cash"
                    />
                    <!-- OFFICE SETTINGS -->

                    <div class="flex items-center md:mt-1" v-for="(slot, index) in sortedSlots" :key="slot.id">
                        <span class="icon mr-2 text-lg" :class="index == 0 ? 'text-grey-darkest' : 'text-white'"><i class="mdi mdi-calendar-check"></i></span>
                        <span class="text-sm md:text-base">{{ slot.date | momentFormat('YYYY-MM-DD', $t('date_selector_format')) }} {{ $t('at') }} {{ slot.time | momentFormatTime($t('time_format')) }}</span>
                    </div>
                    <div class="flex items-center md:mt-1" v-if="sortedSlots.length < item.timeslots.length">
                        <span class="icon mr-2 text-lg text-white"><i class="mdi mdi-calendar-check"></i></span>
                        <span class="text-sm md:text-base text-grey-dark">{{ $t('x_more_availabilities', { count: (item.timeslots.length - sortedSlots.length) }) }}</span>
                    </div>
                </div>
            </div>
            <div class="transition flex rounded-b bg-grey-light group-hover:bg-blue text-grey-darker group-hover:text-white py-1 justify-center">
                <span class="uppercase tracking-wide font-semibold text-sm">{{ $t('Detail_of_the_appointment') }}</span>
            </div>
        </div>
        <timeslot-selection-modal
            :active="showTimeslotSelection"
            @close="hideTimeslotSelectionModal"
            :group="item"></timeslot-selection-modal>
    </div>
</template>
<script>
    import helpers from '@/mixins/helpers'

    import TimeslotSelectionModal from '@/components/Patient/TimeslotSelectionModal.vue'
    import OfficeSettings from '@/components/Patient/OfficeSettings.vue'

    export default {
        name: 'timeslot-group-list-item',

        components: {TimeslotSelectionModal, OfficeSettings},

        mixins: [helpers],

        props: ['item'],

        data () {
            return {
                showTimeslotSelection: false
            }
        },

        computed: {
            sortedSlots () {
                return _.take(_.sortBy(this.item.timeslots, ['date', 'time']), 5)
            }
        },

        methods: {
            handleClick () {
                if (this.item.timeslots.length > 1) {
                    this.showTimeslotSelectionModal()
                } else {
                    this.$router.push({ name: 'timeslot.show', params: { id: this.item.timeslots[0].id } })
                }
            },

            showTimeslotSelectionModal () {
                this.showTimeslotSelection = true
                this.setPreventBodyScroll(true)
            },

            hideTimeslotSelectionModal () {
                this.showTimeslotSelection = false
                this.setPreventBodyScroll(false)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Patient/TimeslotGroupListItem.vue